import React, { Component } from "react";
import ErrorBoundaryMessage from "./components/ErrorBoundaryMessage";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return <ErrorBoundaryMessage />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
